module.exports =
{

  _init: function ()
  {

    this.validate()

    this.onChangeNodes()

    this.onChangeBrackets()

  },

  onChangeNodes: function ()
  {

    var setTotal = this.setTotal

    var validate = this.validate

    $('#modal-nodes').not('.js-ignore').on('keyup change', function ()
    {

      var nodes_price = parseInt($(this).val() || 0) * parseFloat($(this).data('price') || 0.00)

      validate()

      setTotal()

    }).addClass('js-ignore')

  },

  onChangeBrackets: function ()
  {

    var setTotal = this.setTotal

    var validate = this.validate

    $('#modal-brackets').not('.js-ignore').on('keyup change', function ()
    {

      var brackets_price = parseInt($(this).val() || 0) * parseFloat($(this).data('price') || 0.00)

      validate()

      setTotal()

    }).addClass('js-ignore')

  },

  validate: function ()
  {

    if (0 === parseInt($('#modal-nodes').val() || 0) + parseInt($('#modal-brackets').val() || 0))
    {
      $('#modal-submit').prop('disabled', true)
    }

    else
    {
      $('#modal-submit').prop('disabled', false)
    }

  },

  setTotal: function ()
  {

    var price = 0.00

    var nodes = $('#modal-nodes')

    price += parseInt(nodes.val() || 0) * parseFloat(nodes.data('price') || 0.00)

    var brackets = $('#modal-brackets')

    price += parseInt(brackets.val() || 0) * parseFloat(brackets.data('price') || 0.00)

    price += parseFloat($('#modal-shipping').val() || 0.00)

    $('#modal-total').text(Number(price).toLocaleString(undefined, {minimumFractionDigits: 2}))

  }

}